const PICKER_TOKENS = [
  "none",
  "assoonaspossible",
  "aslateaspossible",
  "startnoearlierthan",
  "finishnolaterthan",
  "muststarton",
  "mustfinishon",
];

/**
 * Bryntum renders the Constraint type cell through its ConstraintTypePicker locale, while the
 * combo reads `ganttContext.constraintTypes`. This builds the picker locale from the same
 * translation file so the cell and the combo carry the wording fixed by SPEC-0059 §5.9.
 */
export const constraintTypePickerLocale = (translation) =>
  Object.fromEntries(PICKER_TOKENS.map((token) => [token, translation.ganttContext.constraintTypes[token]]));
